import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=0aeaed13&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aeaed13')) {
      api.createRecord('0aeaed13', component.options)
    } else {
      api.reload('0aeaed13', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=0aeaed13&", function () {
      api.rerender('0aeaed13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Notifications.vue"
export default component.exports